import React from "react";
import cn from "classnames";

import { ImageProps } from "./Image.props";
import styles from "./Image.module.scss";

/**
 * @deprecated
 */
const Image: React.FC<ImageProps> = ({ src, alt, id, testId, className, ariaHidden }: ImageProps): JSX.Element => {
  const imageStyles = cn(styles.image, className);

  return (
    <img
      src={src}
      className={imageStyles}
      id={id}
      data-testid={testId ? `test__${testId}` : undefined}
      alt={alt}
      aria-hidden={ariaHidden}
    />
  );
};

export default Image;
